var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.138 6.671a.667.667 0 0 0-.942-.942l-3.12 3.12-1.262-1.311a.667.667 0 0 0-.96.924l1.733 1.8a.667.667 0 0 0 .951.01l3.6-3.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 .667a7.333 7.333 0 1 0 0 14.666A7.333 7.333 0 0 0 8 .667M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8"
  })));
};
export default SvgCheck;